export default {
  ROOT: 1,
  ADMINISTRADOR: 2,
  USUARIO: 3
}



// WEBPACK FOOTER //
// ./src/models/Permissions.js